export const enums = {
	FREQUENCY: ['Hourly', 'Per shift', 'Periodly'],
	AMOUNT_TYPE: ['Nominal'] // 'Percent',
};
